import useAbTestHotelButtonLabel from './useAbTestHotelButtonLabel'
import useGetGeoentityTypeForListItem from './useGetGeoentityTypeForListItem'
import { GEOENTITY_HOTEL_CELL_TYPE } from '../../store/geoentity/geoentity.constants'
import { CLICKED_BUTTON } from '../analytics/analytics.constants'

export const useGeoentityItemCTALabel = poi => {
  const { variantId, testId, testLabel } = useAbTestHotelButtonLabel('hotel-cta-liste')
  const type = useGetGeoentityTypeForListItem(poi)

  if (type === GEOENTITY_HOTEL_CELL_TYPE) {
    const label = testLabel ?? "Voir l'offre"
    return { label, tagInfo: { [CLICKED_BUTTON]: label, ...(variantId && testId ? { variantId, testId } : {}) } }
  }

  const label = "Plus d'infos"
  return { label, tagInfo: { [CLICKED_BUTTON]: label } }
}
